module.exports = __webpack_public_path__ + "static/media/arrow-down-xsm-light.5375019e.svg";